"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Above imports resolve TS4023
var sc = require("styled-components");
exports.default = sc.default;
exports.css = sc.css;
exports.injectGlobal = sc.injectGlobal;
exports.keyframes = sc.keyframes;
exports.withTheme = sc.withTheme;
exports.ThemeProvider = sc.ThemeProvider;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@skeoh/pic/out/build/theme/index.js
// module id = 13
// module chunks = 0